<template>
    <span class="d-flex align-center ga-1">
        <v-icon :color="iconColor" :icon="icon"/>
        <span>{{ params.value }}</span>
    </span>
</template>

<script setup>
    import { onBeforeMount, ref } from 'vue';
    import { mdiFileExcelOutline, mdiFileImageOutline, mdiFileDocumentOutline, mdiFileCodeOutline, mdiFilePdfBox, mdiFolderOutline } from '@mdi/js';

    const { params } = defineProps(['params']);

    const iconMap = {
        'xls' : mdiFileExcelOutline,
        'xlsx' : mdiFileExcelOutline,
        'csv' : mdiFileExcelOutline,
        'png': mdiFileImageOutline,
        'jpg': mdiFileImageOutline,
        'jpeg': mdiFileImageOutline,
        'bmp': mdiFileImageOutline,
        'gif': mdiFileImageOutline,
        'txt' : mdiFileDocumentOutline,
        'xml' : mdiFileCodeOutline,
        'pdf' : mdiFilePdfBox
    };
    const icon = ref(null);
    const iconColor = ref('black');
    onBeforeMount(() => {        
        if (params.node.rowPinned != 'bottom'){
            icon.value = typeof params.value != 'undefined' && params.value != null ? getFileIcon(params.value) : '';
            iconColor.value = icon.value === mdiFolderOutline ? 'iconFolder' : iconColor.value;
        }
    });

    function getFileIcon(name){
        var extension = name.split('.').pop().toLowerCase();
        return iconMap[extension] || mdiFolderOutline
    }

    function getMdiFileIcon(name){
        var tmp = null;
        if(endsWith(name.toLowerCase(), '.xls') || endsWith(name.toLowerCase(), '.xlsx') ||  endsWith(name.toLowerCase(), '.csv')){
            tmp = mdiFileExcelOutline;
        } else if(endsWith(name.toLowerCase(), '.png') ||
            endsWith(name.toLowerCase(), '.jpg') ||
            endsWith(name.toLowerCase(), '.jpeg') ||
            endsWith(name.toLowerCase(), '.bmp') ||
            endsWith(name.toLowerCase(), '.gif')){
                tmp = mdiFileImageOutline;
            }else if(endsWith(name.toLowerCase(), '.txt')){
                tmp = mdiFileDocumentOutline;
            } else if(endsWith(name.toLowerCase(), '.xml')){
                tmp = mdiFileCodeOutline;
            } else if(endsWith(name.toLowerCase(), '.pdf')){
                tmp = mdiFilePdfBox;
            }
            else{
                tmp = mdiFolderOutline;
                iconColor.value = 'iconFolder'
            }
        return tmp
    }

    function endsWith(str, match) {
        var len;

        if (str == null || !str.length || match == null || !match.length)
            return false;

        len = str.length;

        return str.substring(len - match.length, len) === match;
    }


</script>
